export default function callToActionWidget(editor) {
  editor.DomComponents.addType('eb-call-to-action', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-call-to-action'
    },
    model: {
      defaults: {
        name: 'Call to Action',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-call-to-action' },
        style: {
          'display': 'flex',
          'align-items': 'center',
          'gap': '30px',
          'padding': '40px',
          'background': 'linear-gradient(135deg, #667eea, #764ba2)',
          'border-radius': '12px',
          'color': '#fff',
        },
        components: `
          <div style="flex:1;">
            <h2 style="font-size:28px;font-weight:700;color:#fff;margin:0 0 10px;">Ready to get started?</h2>
            <p style="font-size:16px;color:rgba(255,255,255,0.9);line-height:1.6;margin:0;">Join thousands of satisfied customers and take your business to the next level today.</p>
          </div>
          <div style="flex-shrink:0;">
            <a href="#" style="display:inline-block;padding:16px 36px;background:#fff;color:#667eea;text-decoration:none;border-radius:8px;font-size:16px;font-weight:700;transition:transform 0.2s;white-space:nowrap;">Get Started Now</a>
          </div>
        `,
        traits: [
          { type: 'text', name: 'data-btn-url', label: 'Button URL' },
        ],
      },
    },
  })

  editor.BlockManager.add('eb-call-to-action', {
    label: 'Call to Action',
    category: 'Pro',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4M6,9H18V11H6V9M6,13H16V15H6V13Z"/></svg>',
    content: { type: 'eb-call-to-action' },
  })
}
